import React, { useState, useMemo } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axiosInstance from "../../../services/axiosComman";
import { CloseIcon } from "../../../assets/icons";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { NuInput } from "../../../utils/Inputs";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { toast } from "react-toastify";

function ChangePassword({ data, visible, onClose, refreshData }) {
  const [passwordCheck, setPasswordCheck] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
    password: "",
    retypePassword: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      password: yup
        .string()
        .required("Password is requerd")
        .min(8, "Password must be Min 8 char")
        .matches(
          /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\-_=+;:'",.<>?/\\|[\]{} ]).*$/,
          "Password must contain letters, numbers, and at least one special character"
        ),
      retypePassword: yup
        .string()
        .matches(passwordCheck, "Passwords not match")
        .min(8, "Retype Password must be Min 8 char")
        .required("Retype Password is requerd"),
    }),
    onSubmit: (value, { resetForm }) => {
      setIsLoading(true);
      delete value.retypePassword;
      axiosInstance
        .put(`/User/change_password/${data.userId}`, value)
        .then((res) => {
          if (res.data) {
            setIsLoading(false);
            resetForm();
            onClose();
            refreshData();
            toast.success(<p className="test-sm">{`${res.data.msg||res.data.message}`||"User password updated successfully"}</p>,)
          } else {
            setIsLoading(false);
            toast.error(<p className="test-sm">{`${res.data.msg||res.data.message}`||"User password updated successfully"}</p>,)
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(
            <p className="test-sm">{`${
              err.response.data.msg ||
              err.response.data.message ||
              err.response.data.error ||
              "User password updated successfully"
            }`}</p>
          );
        });
    },
  });

  useMemo(() => {
    setPasswordCheck(formik.values.password);
    // console.log(formik.values.password);
  }, [formik.values.password]);

  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              Change Password
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="overflow-y-auto text-left relative px-6 flex flex-wrap justify-between">
              <NuInput
                formik={formik}
                name="password"
                label="Password"
                width="w-full"
                placeholder="Password"
                type="password"
              />
              <NuInput
                formik={formik}
                name="retypePassword"
                label="Retype Password"
                width="w-full"
                placeholder="Retype Password"
                type="password"
              />
              <div className=" w-full flex items-center justify-end px-6 py-6 rounded-b">
                <CancelButton onClose={resetClose} isLoading={isLoading} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
